import React from "react";
import { useTranslation } from "react-i18next";
import "./RollerLevel.css";
import { Namespaces } from "../components/LanguageSelector";

export default function RollerLevel({ current, next, roller }) {
  const { t } = useTranslation();

  const unopened = current.awards.filter((aw) => !aw.isOpened).length;
  const rollerNameText = roller && roller.name ? `${roller.name},` : "";

  return (
    <div className="roller-level mb-4">
      <div className="roller-level__hint mb-2 mt-2 pl-1">
        {t(`${Namespaces.rollerLevel}.levelHintText`)}
      </div>
      <div className="">
        <div className="level">
          <div className="bg-white text-center shadow rounded">
            <img
              alt={t(`${Namespaces.rollerLevel}.levelImageAltText`)}
              src={current.picture}
              className="level__picture rounded"
            />
          </div>
          {!next && unopened === 0 ? (
            <>
              <p className="pr-4 pl-4 text-left">
                {t(`${Namespaces.rollerLevel}.congratulatoryMessage1`)}
              </p>
              <p className="pr-4 pl-4 text-left">
                {t(`${Namespaces.rollerLevel}.congratulatoryMessage2`)}
              </p>
              <p className="pr-4 pl-4 text-left">
                {t(`${Namespaces.rollerLevel}.congratulatoryMessage3`)}
              </p>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
